var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01074 7.61719H23.003L21.0059 27.2608C20.9093 28.2105 19.9828 28.9391 18.8719 28.9391H6.1419C5.03102 28.9391 4.10449 28.2105 4.00792 27.2608L2.01074 7.61719Z",
    stroke: "#929292",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.19088C1 5.17574 1.95905 4.35278 3.14207 4.35278H22.1184C23.3015 4.35278 24.2605 5.17574 24.2605 6.19088V6.78642C24.2605 7.294 23.781 7.70547 23.1895 7.70547H2.07104C1.47952 7.70547 1 7.294 1 6.78642V6.19088Z",
    stroke: "#929292",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0684 2.8381C10.0684 1.82295 11.0274 1 12.2104 1H13.0515C14.2345 1 15.1936 1.82295 15.1936 2.8381V4.35269H10.0684V2.8381Z",
    stroke: "#929292",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7211 24.8953V12.3962M8.86532 24.8953L7.58008 12.3962M16.5768 24.8953L17.862 12.3962",
    stroke: "#929292",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/Bin.dbf8b8e7e8b6194a3f36fc9d38f1d4fd.svg";
export { ForwardRef as ReactComponent };